import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mata-uang',
  templateUrl: './mata-uang.page.html',
  styleUrls: ['./mata-uang.page.scss'],
})
export class MataUangPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
